// recharge subscription page log out button
const rechargeDiv = document.querySelector('.rc_layout #customer_tab_content .grid__item');
if (rechargeDiv) {
    const logOutDiv = document.createElement('div');
    logOutDiv.id = 'recurring-login-page';
    logOutDiv.classList.add('recharge-logOut');
    logOutDiv.style.marginBottom = '40px';
    logOutDiv.style.marginTop = '-10px';
    
    const logOutLinkTag = document.createElement('a');
    logOutLinkTag.href = '/account/logout';
    logOutLinkTag.innerHTML = 'Log Out';
    logOutLinkTag.style.color = '#FF6200';
    logOutLinkTag.style.textDecoration = 'underline';
    logOutLinkTag.style.textUnderlineOffset = '3px';
    logOutDiv.appendChild(logOutLinkTag);
    
    // const pTag = rechargeDiv.querySelector('.rc_title-bar ~ p');
    // pTag.style.display = 'flex';
    // pTag.style.justifyContent = 'center';
    // pTag.style.gap = '30px';
    // pTag.style.margin = '0';
    // pTag.appendChild(logOutDiv);
    
    
    rechargeDiv.appendChild(logOutDiv);
}

